module.exports = __webpack_public_path__ + "static/scale-model-of-figge-art-museum-in-davenport-iowa-f9f18351bd2328ef0c0ee0d8ccec74c4.png";